import React from 'react';
import Title from '../../../../../@casino/ui/title';
import TableCasino from '../../../../../@casino/ui/table';
import {useRouter} from '../../../../../@casino/useRouter';
import { useDispatch, useSelector } from 'react-redux';
import { setGetListTournament } from '../../store/thunk/setGetListTournament';

const getDateForm = (event_date) => {
    const day = new Date(+event_date).getDate() < 10 ? '0' + new Date(+event_date).getDate() : new Date(+event_date).getDate();
    const month = +new Date(+event_date).getMonth() + 1 < 10? '0' + (+new Date(+event_date).getMonth() + 1) : new Date(+event_date).getMonth() + 1;
    const year = new Date(+event_date).getFullYear();
    
    return `${day}/${month}/${year}`
}

const TournamentList = () => {
    const router = useRouter();
    const dispatch = useDispatch();

    const columns = [
        { id: 'id', label: 'ID'},
        { id: 'name', label: 'Название'},
        { id: 'date_from', label: 'Начало'},
        { id: 'date_to', label: 'Конец'},
        { id: 'min_bet', label: 'Минимальная ставка'},
        { id: 'count_user', label: 'Кол-во участников'},
        { id: 'count_winners', label: 'Кол-во призовых мест'},
        { id: 'fund', label: 'Призовой фонд'},
        { id: 'status', label: 'Статус'}
    ];
    React.useEffect(() => {
        dispatch(setGetListTournament());
    }, [])

    const tournament = useSelector(state => state.tournament.list);
    
    const rows = tournament.map((item) => {
        return {
            id: item.id,
            name: item.name,
            date_from: getDateForm(+item.date_from),
            date_to: getDateForm(+item.date_to),
            min_bet: item.min_bet,
            count_user: '-',
            count_winners: item.count_winners,
            fund: new Intl.NumberFormat('ru-RU').format(item.fund) + '₽',
            status: item.status ? 'Активен' : 'Архив'
        }
    })

    return (
        <div style={{padding: 20, paddingTop: 0}}>
            <Title label="Турниры" />
            <div style={{
                padding: 20, 
                background: '#1b2039', 
                borderRadius: 8, 
                marginBottom: 12,
                display: 'flex',
                justifyContent: 'flex-end'
            }}>
                <span style={{
                    padding: 10, 
                    background: '#ffc324', 
                    borderRadius: 4, 
                    cursor: 'pointer', 
                    color: '#141b33',
                }}
                    onClick={() => router.history.push('/tournament/create')}
                >Создать турнир</span>
            </div>
            <div style={{
                padding: 20, 
                background: '#1b2039', 
                borderRadius: 8, 
            }}>
                <TableCasino
                    route="/tournament/edit/"
                    width={1600}
                    columns={columns}
                    rows={rows} 
                />
            </div>
        </div>
    )
}

export default TournamentList;